interface ValidationFailedProps {
  message: string;
  onRetry: () => void;
}

export function ValidationFailed({ message, onRetry }: ValidationFailedProps) {
  return (
    <div className="py-6 text-center">
      <p className="text-sm font-medium text-gray-900">Connection failed</p>
      <p className="mt-2 text-sm text-gray-500">{message}</p>

      <button
        type="button"
        onClick={onRetry}
        className="mt-6 w-full py-2.5 bg-gray-900 text-white text-sm font-medium hover:bg-gray-800"
      >
        Try again
      </button>
    </div>
  );
}
